// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","container":"_3oVo","input":"amBc","suggestionsContainer":"_1K_D","suggestionsList":"_1Sa8","suggestion":"U83H","suggestionHighlighted":"_3z5P"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Autosuggest/Autosuggest.scss
// module id = 94T0
// module chunks = 0